module.exports = __webpack_public_path__ + "img/zhuanli.a9bad263.png";